import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { AppHeader } from "@/components/Layout";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-slate-50">
      <AppHeader />
      <div className="mx-auto max-w-lg px-5 py-20 text-center" data-testid="payment-cancel-page">
        <AlertCircle className="mx-auto h-10 w-10 text-amber-500" />
        <h1 className="mt-6 text-3xl font-bold tracking-tight text-slate-900">Payment cancelled</h1>
        <p className="mt-3 text-slate-600">
          Nothing was charged. You can still browse every Australian recall, but SMS alerts stay off until you subscribe.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/settings#sms-alerts" data-testid="payment-cancel-settings" className="rounded-md bg-red-700 px-5 py-3 text-sm font-semibold text-white hover:bg-red-800">
            Try again
          </Link>
          <Link to="/alerts" className="rounded-md border border-slate-300 px-5 py-3 text-sm font-medium text-slate-800">
            Browse recalls
          </Link>
        </div>
      </div>
    </div>
  );
}
